'use client';

import { useDrawer } from '@cat-ecom/pcc-components';
import { FC, PropsWithChildren, createContext, useContext } from 'react';

const storeInfoCtx = createContext<ReturnType<typeof useDrawer>>(null);

export const useStoreInfoDrawer = () => useContext(storeInfoCtx);

export const StoreInfoDrawerProvider: FC<PropsWithChildren> = ({ children }) => {
  const storeInfoDrawer = useDrawer();

  return (
    <storeInfoCtx.Provider value={storeInfoDrawer}>
      {children}
    </storeInfoCtx.Provider>
  );
};
